const feedTypes = ['sequence', 'epoch'];
export const DEFAULT_FEED_TYPE = 'sequence';
export function isFeedType(type) {
  return typeof type === 'string' && feedTypes.includes(type);
}
export function assertFeedType(type) {
  if (!isFeedType(type)) {
    throw new TypeError('invalid feed type');
  }
}